import { Divider, Stack, Typography } from "@mui/material";
import { TerminalRounded as DocsIcon } from "@mui/icons-material";
import ApiIcon from "@mui-symbols-material/w400/DeployedCodeAccountFilledRounded";

import { useStore, observer } from "../../service/mobx";
import { NavListItem } from "./index";
import ToolTip from "../Tooltip";

function Developers() {
  const { layout } = useStore();

  return (
    <Stack useFlexGap spacing={1}>
      <Typography
        component="p"
        variant="titleSm"
        color="secondary"
        align="center"
        pl={layout.navOpen ? 2 : undefined}
        width={layout.navOpen ? 0 : 63}
      >
        {layout.navOpen ? "Developers" : "Devs"}
      </Typography>
      <ToolTip placement="right" title={layout.navOpen ? "" : "Plan"}>
        <NavListItem
          line1="Plan"
          href="/api"
          leading={{ Icon: () => <ApiIcon sx={{ width: 30, height: 30 }} /> }}
        />
      </ToolTip>
      <ToolTip placement="right" title={layout.navOpen ? "" : "Docs"}>
        <NavListItem
          line1="docs"
          target="_blank"
          href="https://docs.bytez.com"
          leading={{ Icon: DocsIcon }}
        />
      </ToolTip>
      <Divider />
    </Stack>
  );
}

export default observer(Developers);
